module.exports = __webpack_public_path__ + "media/images/icons/file-be787e195cb331e6a0fb9898239bb374.svg";